import request from "../utils/request";

export const list = (type) => (data) => request.get(`/api/user/${type}`, data);
export const select = () => request.get("/api/user_select",);
export const create = (data) => request.post("/api/user", data);
export const update = (id, data) => request.put(`/api/user/${id}`, data);
export const remove = (id) => request.del(`/api/user/${id}`);
export const get = (id) => request.get(`/api/user/${id}`);